<template>
    <router-view v-slot="{ Component, route }">
        <transition name="fade-transform" mode="out-in">
            <!-- 删除key保证transition只判断一次，解决三级路由切换白屏 -->
            <component v-if="route.meta.noCache" :is="Component" :key="routeKey" />
            <keep-alive v-else>
                <component :is="Component" />
            </keep-alive>
        </transition>
    </router-view>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const routeKey = computed(() => route.path + Math.random())
</script>

<style lang="scss" scoped></style>
